import React from 'react'
import { TFunction } from 'react-i18next'
import { GridColDef } from '@mui/x-data-grid'
import { Grid, Typography } from '@mui/material'

import { getAssetURL } from 'lib/utility/GetAssetUrl'
import { formatNumbers } from 'lib/Helper'

const columns = (t: TFunction) => {
  const columnsData: GridColDef[] = [
    {
      field: 'id',
      headerName: `${t('reporting.overview.id')}`,
    },
    {
      field: 'tool',
      headerName: `${t('reporting.overview.tool')}`,
      sortable: false,
      flex: 2,
      minWidth: 250,
      renderCell: ({ row: { tool = '', type } = {} }) => (
        <Grid alignItems={'center'} display={'flex'} width={'100%'}>
          <img
            alt="tool"
            src={getAssetURL(`/reporting/tool-icons/${type}.svg`)}
          />
          <Typography variant="inherit" noWrap padding={'0px 35px 0 12px'}>
            {tool}
          </Typography>
        </Grid>
      ),
    },
    {
      field: 'project',
      sortable: false,
      headerName: `${t('reporting.overview.project')}`,
      flex: 2,
      minWidth: 250,
      renderCell: ({ row: { project = '' } = {} }) => (
        <Typography variant="inherit" noWrap width={'auto'}>
          {project}
        </Typography>
      ),
    },
    {
      field: 'contributions',
      sortable: false,
      headerName: `${t('reporting.overview.NoofContributions')}`,
      flex: 1,
      minWidth: 150,
      align: 'right',
      headerAlign: 'right',
      renderCell: ({ row: { contributions = '' } = {} }) =>
        formatNumbers(contributions),
    },
  ]
  return columnsData
}

export default columns
